import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import {
  PhxDropdownModule,
  PhxListModule,
  PhxInputModule,
  PhxDialogModule,
  PhxTooltipModule,
} from 'phx-core';

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { CommonPipesModule } from '@app/pipes/module';
import { CommonComponentsModule } from '@app/common-components/module';
import { TruncateBreadcrumbModule } from '@app/admin/groups/truncate-directive/module';

import { HierarchyMultiSelectWithCounterComponent } from './hierarchy-multi-select-with-counter.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NzDividerModule,
    NzDropDownModule,
    NzFormModule,
    NzIconModule,
    NzCheckboxModule,
    NzInputModule,
    CommonComponentsModule,
    CommonPipesModule,
    TruncateBreadcrumbModule,
    NzRadioModule,
    PhxListModule,
    PhxDropdownModule,
    PhxInputModule,
    PhxDialogModule,
    PhxTooltipModule,
  ],
  declarations: [
    HierarchyMultiSelectWithCounterComponent,
  ],
  exports: [
    HierarchyMultiSelectWithCounterComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [],
})
export class HierarchyMultiSelectWithCounterModule { }
